import { Icon, IconSize, Tooltip } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import FavoriteStar from "components/sidebar/BusItem/FavoriteStar";
import "./DetailPaneHeader.scss";

const FAVORITE_STAR_ICON_SIZE = 16;

export const ADD_TO_FAVORITES_LABEL = "Add to favorites";
export const REMOVE_FROM_FAVORITES_LABEL = "Remove from favorites";

interface DetailPaneHeaderProps {
    title: string;
    icon: React.ReactNode;
    onCancel: () => void;
    readonly energyTag: React.ReactNode;
    readonly chargingTag?: React.ReactNode;
    readonly capacityTag?: React.ReactNode;
    readonly statusChip?: React.ReactNode;
    readonly maybeOpenLocalStudies?: () => void;
    readonly isFavorite?: boolean;
    readonly onToggleFavorite?: () => void;
}

const DetailPaneHeader: React.FC<DetailPaneHeaderProps> = (props) => {
    const {
        title,
        icon,
        onCancel,
        energyTag,
        chargingTag,
        capacityTag,
        statusChip,
        maybeOpenLocalStudies,
        isFavorite,
        onToggleFavorite
    } = props;

    return (
        <div className="DetailPaneHeader-wrapper">
            {icon}
            <h5 className="bp5-heading">{title}</h5>
            <div className="DetailPaneHeader-actions">
                {onToggleFavorite && (
                    <Tooltip
                        className="DetailPaneHeader-action-tooltip"
                        content={
                            isFavorite
                                ? REMOVE_FROM_FAVORITES_LABEL
                                : ADD_TO_FAVORITES_LABEL
                        }
                        placement="left"
                    >
                        <button
                            type="button"
                            className="DetailPaneHeader-icon-button DetailPaneHeader-favorite-button"
                            aria-label={
                                isFavorite
                                    ? REMOVE_FROM_FAVORITES_LABEL
                                    : ADD_TO_FAVORITES_LABEL
                            }
                            aria-pressed={isFavorite}
                            onClick={onToggleFavorite}
                        >
                            <FavoriteStar
                                size={FAVORITE_STAR_ICON_SIZE}
                                filled={isFavorite === true}
                            />
                        </button>
                    </Tooltip>
                )}
                {maybeOpenLocalStudies && (
                    <Tooltip
                        className="DetailPaneHeader-action-tooltip"
                        content="Perform detailed analysis"
                        placement="left"
                    >
                        <Icon
                            className="DetailPaneHeader-icon-button"
                            icon={IconNames.CLEAN}
                            size={IconSize.STANDARD}
                            onClick={maybeOpenLocalStudies}
                        />
                    </Tooltip>
                )}
                <Icon
                    className="DetailPaneHeader-icon-button"
                    icon="cross"
                    size={IconSize.STANDARD}
                    onClick={onCancel}
                />
            </div>

            <div className="DetailPaneHeader-capacity-energy-tags-wrapper">
                <div className="DetailPaneHeader-energy-tag-wrapper">
                    {energyTag}
                </div>
                {chargingTag && (
                    <div className="DetailPaneHeader-charging-capacity-tag-wrapper">
                        {chargingTag}
                    </div>
                )}
                {capacityTag && (
                    <div className="DetailPaneHeader-charging-capacity-tag-wrapper">
                        {capacityTag}
                    </div>
                )}
                {statusChip && (
                    <div className="DetailPaneHeader-status-chip-wrapper">
                        {statusChip}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DetailPaneHeader;
